module.exports = __webpack_public_path__ + "../assets/dekstop-4.jpg";